export const PRIMARY_COLLECTIONS = [
  {
    slug: "madhav",
    name: "Madhav",
    description: "The Krishna aesthetic, interpreted through Eternal Order.",
    tags: ["krishna", "madhav", "murali"],
    hero_image: "/assets/madhav-tile2.png",
    seo_title: "Madhav Collection | Eternal Order",
    seo_meta_description: "Shop Madhav collection from Eternal Order.",
  },
  {
    slug: "shiva",
    name: "Shiva",
    description: "A tribute to stillness, power, and cosmic intensity.",
    tags: ["shiva", "mahadev", "rudra"],
    hero_image: "/assets/shiva-tile3.png",
    seo_title: "Shiva Collection | Eternal Order",
    seo_meta_description: "Shop Shiva collection from Eternal Order.",
  },
  {
    slug: "veergatha",
    name: "Veergatha",
    description: "Stories of courage and sacrifice, translated into wearable expression.",
    tags: ["veergatha", "veer", "valor"],
    hero_image: "/assets/whats-new-veergatha.png",
    seo_title: "Veergatha Collection | Eternal Order",
    seo_meta_description: "Shop VEERGATHA collection from Eternal Order.",
  },
  {
    slug: "maryada",
    name: "Maryada",
    description: "Discipline, honor, and timeless character.",
    tags: ["maryada", "ram", "legacy"],
    hero_image: "/assets/maryada-tile4.png",
    seo_title: "Maryada Collection | Eternal Order",
    seo_meta_description: "Shop Maryada collection from Eternal Order.",
  },
  {
    slug: "anjaneya",
    name: "Anjaneya",
    description: "Devotion, courage, and unwavering force.",
    tags: ["anjaneya", "veer", "bajrangi"],
    hero_image: "/assets/anjaneya-tile5.png",
    seo_title: "Anjaneya Collection | Eternal Order",
    seo_meta_description: "Shop Anjaneya collection from Eternal Order.",
  },
  {
    slug: "acid-wash-premium",
    name: "Acid Wash Premium",
    description: "Plain, elevated, and built with attitude.",
    tags: ["acid wash", "premium"],
    hero_image: "/assets/whats-new-acid-wash-premium.png",
    seo_title: "Acid Wash Premium | Eternal Order",
    seo_meta_description: "Shop Acid Wash Premium collection from Eternal Order.",
  },
];
